import { CheckoutPayload } from '../../models/checkout/checkout-payload.interface';
import { mockCheckoutContract } from './checkout-contract.mock';
import { mockCheckoutItem } from './checkout-item.mock';
import { mockCheckoutPerson } from './checkout-person.mock';

export const mockCheckoutPayload: CheckoutPayload = {
  clientCode: 'WHIRL',
  channelCode: 'DGOLR',
  systemCode: 'DandG_IPR',
  journeyCode: 'REG',
  businessEventCode: 'COCRE',
  businessSource: 'WEB',
  interactionId: '18b73143-0766-45b3-8057-69f3cf8f341a',
  userId: 'USOLR',
  quoteId: 'DGQ0001262431',
  person: mockCheckoutPerson,
  item: [mockCheckoutItem],
  contract: mockCheckoutContract,
};
